/**
 * External Dependencies
 */
import 'jquery'; // jQuery

import AOS from 'aos'; // Animate On Scroll
import SmoothScrollTop from 'smooth-scroll-top'; // Smooth Scroll Top
import SimpleParallax from "simple-parallax-js"; // Simple Parallax

import './components/responsive';

import Swiper from 'swiper/bundle'; // Swiper JS
import 'swiper/css/bundle'; // import Swiper styles

/* import mmenu + menu */
import 'mmenu-js';
import './components/menu';

$(() => {
  /**
   * WP Evo Theme version
   */
  console.log('- 💎 WP Evo Theme v0.0.1 - Made with 💗 - ©️ S2i Evolution');

  //////////////////////
  // AXEPTIO //
  /////////////////////

  window._axcb = window._axcb || [];
  window._axcb.push(function(sdk){

    console.log('axeptio SDK - loaded');

    $('.axeptio').on('click touch', function(){
      sdk.openCookies();
    });
  });

  ///////// Init AOS  /////////
  AOS.init({
    //disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    disable: 'mobile',
    once: true,
    animatedClassName: 'aos-animate', // class applied on animation
  });
  console.log('[lib] > Animate On Scroll loaded');

  ///////// Init Smooth Scroll Top  /////////
  const scrollTop = new SmoothScrollTop({
    position: 'right',
    bgColor: '#ef5b5b',
  });
  scrollTop.init();
  console.log('[lib] > Smooth Scroll Top loaded');

  check_header();
  $(window).on("scroll", check_header);
  $(window).on("resize", check_header);

  ///////// Init Simple Parallax  /////////
  const simpleParallax = require('simple-parallax-js');

  if($(window).width() > 	1280) {


    var image = document.getElementsByClassName('thumbnail');
    new simpleParallax(image, {
      orientation: 'right',
      overflow: true
    });

    var image_left = document.getElementsByClassName('thumbnail-left');
    new simpleParallax(image_left, {
      orientation: 'left',
      transition: 'cubic-bezier(0,0,0,1)',
      overflow: true
    });
  }

  /// SCROLL ///
  // $('a[href^="#"]').not('.menu-trigger').addClass("scroll");

  $('.scroll').on('click touch', function () { // Au clic sur un élément
    scrollTo(this.hash, 750);
  });

  //$(document).on("scroll", onScroll);

});

function scrollTo(page, speed) {
  $('html, body').animate({ scrollTop: $(page).offset().top - $('header').height() }, speed); // Go
  return false;
}

///// FIXED HEADER /////
function check_header() {
  if ($(window).scrollTop() < 1 && $(window).width() > 992) {
    $("header").removeClass("second_style");
  }
  if ($(window).scrollTop() >= 1 || $(window).width() < 992) {
    $("header").addClass("second_style");
  }
}

///// CLIC SUR LES CARDS /////
$('.card').on('click', function () {
  document.location.href = $(this).find('a').attr('href');
});

///// SWIPE JS /////
var swiper = new Swiper(".mySwiperClients", {
  slidesPerView: 3,
  spaceBetween: 30,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    reverseDirection: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  // Responsive
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
    1536: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
    1903: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
});

///// CONTENU ACCORDEON COLLASPE /////
/* Optional Javascript to close the radio button version by clicking it again */
var myRadios = document.getElementsByName('tabs2');
var setCheck;
var x = 0;
for(x = 0; x < myRadios.length; x++){
  myRadios[x].onclick = function(){
    if(setCheck != this){
      setCheck = this;
    }else{
      this.checked = false;
      setCheck = null;
    }
  };
}

///// HAUTEUR DE LA FENETRE /////

// Get the size of the device screen
//var screenHeight = screen.height;

// Showing the sizes on the webpage
// var x = document.getElementById("screen");
// x.style.height = screenHeight+"px"


///// HAUTEUR DU CONTENU /////
// if ($(window).width() > 1024) {
//   var hauteur = document.getElementById('content').clientHeight;
//   var x = document.getElementById("screen");
//   x.style.height = hauteur+"px"
// }
